import React, { forwardRef, useCallback, useEffect, useState } from 'react'
import { Header, Page } from 'components'
import { Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@material-ui/core'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import MaterialTable from 'material-table'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import { useReportService } from 'hooks/useReportService'
import LastPageIcon from '@material-ui/icons/LastPage'
import { DetailPanel } from './components/DetailPanel'
import { MenuAcoes } from './components/MenuAcoes'

import useStyles from './styles'

export const ReportPage = (props) => {
  const { route } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const [report, setReport] = useState([])
  const reportService = useReportService()
  const [processandoReport, setProcessandoReport] = useState(false)

  const fetchListarReports = useCallback(async () => {
    const response = await reportService.listarReportDeUsuarioAsync(setProcessandoReport)
    setReport(response)
  
  }, [])

  useEffect(() => {
    fetchListarReports()
    
  }, [fetchListarReports])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          <Grid alignItems="flex-end" container justifyContent="space-between" spacing={3}>
            <Grid item>
              <Typography className={classes.pageTitle}>
                <b>FEEDBACKS REGISTRADOS</b>
              </Typography>
            </Grid>
            <Grid item>
              <MenuAcoes />
            </Grid>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
              <Divider />
          </Grid>
          <Grid item xs={12} sm={12} md={12} style={{marginTop: '10px'}}>
            <MaterialTable
              title=""
              localization={{
                body: {
                  emptyDataSourceMessage: processandoReport ? (
                    <CircularProgress disableShrink />
                  ) : (
                    'Nenhum feedback cadastrado'
                  ),
                  filterRow: {
                    filterTooltip: 'Filtro',
                  },
                },
                header: {
                  actions: 'Excluir',
                },
              }}
              detailPanel={(rowData) => <DetailPanel idReportSelecionado={rowData.id} />}
              onRowClick={(event, rowData, togglePanel) => togglePanel()}
              data={report}
              columns={[
                {
                  title: 'Tipo de Feedback',
                  render: (rowData) => rowData.tipo_report,
                },
                {
                  title: 'Data de Abertura',
                  render: (rowData) => moment(rowData.createdAt).format('LLLL'),
                },
                {
                  title: 'Status',
                  render: (rowData) => rowData.status,
                },
              ]}
              options={{
                actionsColumnIndex: -1,
                search: false,
                pageSize: 20,

                headerStyle: {
                  backgroundColor: '#f4f6f8',
                },
                toolbar: false,
              }}
              icons={{
                SortArrow: forwardRef((propsSortArrow, ref) => (
                  <ArrowDownwardIcon {...propsSortArrow} ref={ref} />
                )),
                NextPage: forwardRef((propsNextPage, ref) => (
                  <NavigateNextIcon {...propsNextPage} ref={ref} />
                )),
                DetailPanel: forwardRef((propsNextPage, ref) => (
                  <NavigateNextIcon {...propsNextPage} ref={ref} />
                )),
                PreviousPage: forwardRef((propsPreviousPage, ref) => (
                  <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />
                )),
                FirstPage: forwardRef((propsFirstPage, ref) => (
                  <FirstPageIcon {...propsFirstPage} ref={ref} />
                )),
                LastPage: forwardRef((propsLastPage, ref) => (
                  <LastPageIcon {...propsLastPage} ref={ref} />
                )),
              }}
              style={{
                padding: '16px',
                fontSize: '13px',
                textAlign: 'left',
                fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                fontWeight: '400',
                lineHeight: '21px',

                letterSpacing: '-0.05px',
                verticalAlign: 'inherit',
              }}
            />
          </Grid>
        </CardContent>
      </Card>
    </Page>
  )
}
